import { useState, useEffect } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import { db, auth } from '../firebase/firebaseConfig';

export const useAccountStatus = () => {
    const [isAccountActive, setIsAccountActive] = useState(true);
    const [statusLoading, setStatusLoading] = useState(true);

    useEffect(() => {
        let unsubscribeSnapshot = null;

        const unsubscribeAuth = auth.onAuthStateChanged((currentUser) => {
            if (unsubscribeSnapshot) {
                unsubscribeSnapshot();
                unsubscribeSnapshot = null;
            }

            if (!currentUser) {
                console.log('[AccountStatus] No user logged in, defaulting active');
                setIsAccountActive(true);
                setStatusLoading(false);
                return;
            }

            console.log('[AccountStatus] Watching account_status for UID:', currentUser.uid);

            const statusRef = doc(db, 'account_status', currentUser.uid);
            unsubscribeSnapshot = onSnapshot(
                statusRef,
                (snap) => {
                    if (snap.exists()) {
                        const data = snap.data();
                        console.log('[AccountStatus] Document found:', data);
                        setIsAccountActive(data.isActive !== false);
                    } else {
                        console.log('[AccountStatus] No document found for UID:', currentUser.uid, '— defaulting to active');
                        setIsAccountActive(true);
                    }
                    setStatusLoading(false);
                },
                (err) => {
                    console.error('[AccountStatus] Firestore error:', err.code, err.message);
                    setIsAccountActive(true);
                    setStatusLoading(false);
                }
            );
        });

        return () => {
            unsubscribeAuth();
            if (unsubscribeSnapshot) unsubscribeSnapshot();
        };
    }, []);

    return { isAccountActive, statusLoading };
};

export default useAccountStatus;
